import React from 'react';

export default function Container({ children, ...props }) {
  return (
    <section {...props} data-container>
      {children}
    </section>
  );
}
